// extracted by mini-css-extract-plugin
export default {"rt":"Switch_rt__R9mVf","rt_whide":"Switch_rt_whide__9YNC3","lbl":"Switch_lbl__bWgGd","sw":"Switch_sw__y20ve","sw_ball":"Switch_sw_ball__LLSns","sw__act":"Switch_sw__act__F3fI4"};